/* eslint-disable @typescript-eslint/naming-convention */
export const DefectType = {
  minor: 'MINOR',
  major: 'MAJOR',
} as const;

export type DefectType = typeof DefectType[keyof typeof DefectType];
